import axios from 'axios'

// 创建一个 axios 实例
const apiInstance = axios.create({
  baseURL: 'https://myd-cloud.iscn.org.cn',
})

export default apiInstance



// WEBPACK FOOTER //
// ./src/utils/request.js